<template>
    <LoginLayout>
        <b-card            class="text-center">
            <h1>Airline Check-in</h1>
            <p>{{ error || "We are processing your check-in request..." }}</p>
</b-card>
    </LoginLayout>
</template>

<script>
    import LoginLayout from "@/partials/login-layout";
    import { airlineCheckinRedirect } from "./services";
	export default {
		components: {
            LoginLayout: LoginLayout,
		},
		data() {
			return {
                error: null,
			};
		},
        async mounted() {
            this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });
            setTimeout(() => {
                this.handleAirlineCheckinRedirect();
            }, 3000); 
        },
        methods: {
            async handleAirlineCheckinRedirect() {
                if (this.$route.params.airlineCode) {
                    const result = await airlineCheckinRedirect(this.$route.params.airlineCode)
                    if (result && !result.error && result.data && result.data.url) {
                        // Push the user to the external airline check-in page
                        window.location.href = result.data.url;
                        return;
                    }
                }
                this.error = "Unable to process your check-in request. Please try again later.";
                this.$store.dispatch("spinner/updateLoadingAction", false, {
                    root: true,
                });  
            }
        },
    };
</script>
<style lang="scss">
@import "../../assets/scss/index.scss";
</style>
